import styled from "styled-components";
import logoTitleImage from "../images/warp_logo_title.png";
import backgroundImage1 from "../images/us_background_1.png";
import backgroundImage2 from "../images/us_background_2.png";
import backgroundImage3 from "../images/us_background_3.png";
import backgroundImage4 from "../images/us_background_4.png";
import backgroundImage5 from "../images/warp_us_background_5.png";
import iconArrowLeft from "../images/icon_arrow_left.png";

function Us() {
  return (
    <WholeDiv>
      <div className="div1">
        <div className="div1-contentdiv">
          <div className="div1-content-leftdiv"></div>
          <div className="div1-content-rightdiv">
            <div className="div1-title1">가장 빠른 비즈니스 지름길,</div>
            <img
              className="div1-logo-image"
              src={logoTitleImage}
              alt="incourse 인코스 비즈니스 뉴스레터 1인 기업가 디지털노마드 디지털 노마드"
            />
            <div className="div1-subtitle">
              '지금 한국에서 하면 돈 되는 정보' <br></br>와프 스토리가 전합니다.
            </div>
            <div className="div1-content-text">
              포화된 시장, 똑같은 방법론 <br></br>이미 한국에서 퍼진 콘텐츠로는{" "}
              <br></br>
              비즈니스에서 우위를 점할 수 없습니다. <br></br>
              <br></br>글로벌 성공사례를 바탕으로<br></br>
              로컬에 적용하는 것이 가장 효과적입니다.<br></br> <br></br>무한
              경쟁의 시대에서 추월하고 싶다면<br></br> 매일 100명에게 열리는
              <br></br> 와프 스토리에 도전해보세요.
            </div>
          </div>
        </div>
      </div>
      <div className="div2">
        <div className="div2-contentdiv">
          <div className="div2-content-leftdiv"></div>
          <div className="div2-content-rightdiv">
            <div className="div2-subtitle">매일 100명만 읽을 수 있다고?</div>
            <div className="div2-content-text">
              창의적인 아이디어,<br></br> 시스템에 대한 이해를 바탕으로 한
              탁월한 전략<br></br>
              <br></br>
              이러한 것들은 경쟁에서 우위를 점하게 해주며<br></br> 그 자체로
              ‘돈’입니다.<br></br>
              <br></br>
              그러나 시장의 모든 플레이어가 알게 되는 순간 <br></br>전부
              똑같아져 차별성이 사라지겠죠. <br></br>
              <br></br>모두가 알 수 있는 정보는 <br></br>아무에게도 가치 없는
              정보입니다. <br></br>
              <br></br>와프 스토리는 한정된 정보의 힘을 믿고, <br></br>그렇기
              때문에 정보의 공급을 제한합니다.
            </div>
          </div>
        </div>
      </div>
      <div className="div3">
        <div className="div3-contentdiv">
          <div className="div3-content-leftdiv"></div>
          <div className="div3-content-rightdiv">
            <div className="div3-subtitle">
              그렇다면 한국에서 돈이 되는 정보는 뭘까요.
            </div>
            <div className="div3-content-text">
              글로벌 억만장자들의 <br></br>비즈니스 테크닉입니다.<br></br>
              <br></br> 10배의 인구, 10배의 시장<br></br> 좋은 환경과 돈의
              크기에 힘입어<br></br> 수많은 실험이 이뤄집니다.<br></br>
              <br></br>
              글로벌에서 성공한 1인 기업가들의 성공 노하우는<br></br> ‘2023 현재
              지구에서 돈 가장 쉽게 버는 법’과 동치입니다. <br></br>
              <br></br>와프 스토리는 인터뷰를 기반으로 <br></br>1인 기업가들의
              성공 노하우가 <br></br>현재 한국에 맞게 가공되어 담겼습니다.
            </div>
          </div>
        </div>
      </div>
      <div className="div4">
        <div className="div4-contentdiv">
          <div className="div4-content-leftdiv"></div>
          <div className="div4-content-rightdiv">
            <div className="div4-subtitle">비즈니스는 경쟁입니다.</div>
            <div className="div4-content-text">
              경쟁에서의 승리 없이 쟁취되는 돈은 없습니다. <br></br>
              <br></br>현재 비즈니스 생태계는 모든 것들이 <br></br>순식간에
              생겼다가 사라지곤 하죠. <br></br>
              <br></br>세상의 속도는 매우 빠릅니다. <br></br>
              <br></br>와프 스토리는 0.1초의 촌각을 다투는 상황에서<br></br>
              극도로 효율적인 당신의 팀입니다. <br></br>
              <br></br>당신이 경쟁에서 승리하여<br></br>
              최종적으로 ‘돈’을 가져갈 수 있도록 돕겠습니다.
            </div>
          </div>
        </div>
      </div>
      <div className="div5">
        <div className="div5-contentdiv">
          <div className="div5-content-leftdiv"></div>
          <div className="div5-content-rightdiv">
            <div className="div5-subtitle">
              당신의 추월, 지금부터 시작입니다.
            </div>
            <div className="div5-content-text">
              지금 회원가입 시 <br></br>얼리 커뮤니티 회원의 <br></br>
              인증 티켓을 지급합니다. <br></br>
              <br></br>지금 회원가입하여 <br></br>와프 스토리의 프리미엄 정보를
              놓치지 마세요.
            </div>
            <div className="div5-buttondiv">
              <div className="div5-button-text">회원가입하기</div>
              <img
                className="div5-button-logo"
                src={iconArrowLeft}
                alt="인코스 회원가입 incourse 1인 기업가"
              />
            </div>
          </div>
        </div>
      </div>
    </WholeDiv>
  );
}

export default Us;

const WholeDiv = styled.div`
  line-height: normal;

  .div1 {
    background-color: black;
    background-image: url(${backgroundImage1});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 1230px;
    color: white;

    .div1-contentdiv {
      .div1-content-leftdiv {
        float: left;
        width: 50%;
      }

      .div1-content-rightdiv {
        float: right;
        width: 50%;

        .div1-title1 {
          font-size: 40px;
          font-weight: 600;
          margin-top: 200px;
        }

        .div1-logo-image {
          width: 594px;
          margin-top: 22px;
        }

        .div1-subtitle {
          font-size: 32px;
          font-weight: 600;
          margin-top: 120px;
        }

        .div1-content-text {
          font-size: 22px;
          font-weight: 400;
          margin-top: 34px;
        }
      }
    }
  }

  .div2 {
    background-color: #efeded;
    height: 1070px;
    background-image: url(${backgroundImage2});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .div2-contentdiv {
      .div2-content-leftdiv {
        float: left;
        width: 50%;
      }

      .div2-content-rightdiv {
        float: right;
        width: 50%;
        .div2-subtitle {
          font-size: 32px;
          font-weight: 600;
          margin-top: 216px;
        }
        .div2-content-text {
          font-size: 22px;
          font-weight: 400;
          margin-top: 58px;
        }
      }
    }
  }

  .div3 {
    background-color: #f6f5f3;
    height: 1070px;
    background-image: url(${backgroundImage3});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    .div3-contentdiv {
      .div3-content-leftdiv {
        float: left;
        width: 50%;
      }

      .div3-content-rightdiv {
        float: right;
        width: 50%;
        .div3-subtitle {
          font-size: 32px;
          font-weight: 600;
          margin-top: 240px;
        }
        .div3-content-text {
          font-size: 22px;
          font-weight: 400;
          margin-top: 58px;
        }
      }
    }
  }

  .div4 {
    background-color: #393832;
    height: 1070px;
    background-image: url(${backgroundImage4});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: white;

    .div4-contentdiv {
      .div4-content-leftdiv {
        float: left;
        width: 50%;
      }

      .div4-content-rightdiv {
        float: right;
        width: 50%;
        .div4-subtitle {
          font-size: 32px;
          font-weight: 600;
          margin-top: 328px;
        }
        .div4-content-text {
          font-size: 22px;
          font-weight: 400;
          margin-top: 58px;
        }
      }
    }
  }

  .div5 {
    background-color: black;
    height: 1070px;
    background-image: url(${backgroundImage5});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: white;

    .div5-contentdiv {
      .div5-content-leftdiv {
        float: left;
        width: 50%;
      }

      .div5-content-rightdiv {
        float: right;
        width: 50%;
        .div5-subtitle {
          font-size: 32px;
          font-weight: 600;
          margin-top: 210px;
        }
        .div5-content-text {
          font-size: 22px;
          font-weight: 400;
          margin-top: 60px;
        }
        .div5-buttondiv {
          margin-top: 120px;
          width: 404px;
          height: 97px;
          background-color: #8e35ff;
          color: white;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .div5-button-text {
            font-size: 22px;
            font-weight: 700;
            margin-left: 30px;
          }

          .div5-button-logo {
            width: 25px;
            margin-right: 30px;
          }
        }
      }
    }
  }
`;
